<template>
  <template v-if="hasArticles">
    <BlockTitle :subtitle="subtitle" :title="title" />

    <ArticleCardsCarousel :articles="articles" />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ArticleCardsList } from '@backmarket/http-api/src/api-specs-content'

import type { ContentBlockProps } from '../../models/content-block'
import ArticleCardsCarousel, {
  type Article,
} from '../../shared-components/ArticleCardsCarousel/ArticleCardsCarousel.vue'
import { BlockTitle } from '../../shared-components/BlockTitle'

export type ArticleCardsListProps = ArticleCardsList & ContentBlockProps
const props = withDefaults(defineProps<ArticleCardsListProps>(), {
  title: '',
  subtitle: '',
})

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])

const articles = computed(() =>
  props.guides.map((guide) => {
    const { src, alt, ...imageProps } = guide.image

    const article: Article = {
      category: guide.translatedCategory,
      id: guide.id,
      imageAlt: alt,
      imageSrc: src,
      link: guide.link,
      text: guide.text,
      title: guide.title,
      imageProps,
    }

    return article
  }),
)

const hasArticles = computed(() => articles.value.length > 0)
</script>
